import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { pushNotificationService } from "./services/push-notifications";

// Initialize push notifications when app loads
if (typeof window !== 'undefined') {
  pushNotificationService.initialize().then((success) => {
    if (success) {
      console.log('Push notifications initialized successfully');
    } else {
      console.log('Push notifications initialization failed');
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
